<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent && localService.languageContent.reservation">
  <app-popup-header title="{{localService.languageContent.reservation.queue}}" [isRefresh]="true"
    (onRefresh)="onLoad()"></app-popup-header>
  <div class="modal-body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
    <div class="box">
      <div>
        <app-label [Text]="localService.languageContent.reservation.session_user" [IsMandatory]="true"></app-label>
      </div>
      <div class="row">
        <div class="col-8">
          <app-business-relationship [businessId]="businessId" (onUserUpdated)="onUserUpdated($event)"
            [relationShipType]="relationShipType" [relationShipRole]="relationShipRole"></app-business-relationship>
        </div>
        <div class="col-4">
          <input autocomplete="off" type="text" maxlength="20" [(ngModel)]="userName"
            [ngClass]="userName != '' ? 'en': ''" title="{{localService.languageContent.reservation.name}}"
            placeholder="{{localService.languageContent.reservation.name}}" />
        </div>
      </div>
      <div class="row">
        <div class="col-8">
          <app-label [Text]="localService.languageContent.reservation.seat_count" [IsMandatory]="true"></app-label>
        </div>
        <div class="col-4">
          <input autocomplete="off" type="number" class="number" (keypress)="localService.isNumberOnly($event)" min="1"
            [(ngModel)]="seatCount" [ngClass]="seatCount != null ? 'en': ''"
            title="{{localService.languageContent.reservation.seat_count}}"
            placeholder="{{localService.languageContent.reservation.seat_count}}" />
        </div>
      </div>
      <div class="row">
        <div class="col-8">
          <span *ngIf="message != ''" [ngStyle]="{'color': isRedAlert ? 'orangered' : 'darkgreen' }">{{message}}</span>
        </div>
        <div class="col-4" style="text-align:right">
          <button type="button" class="btn btn-primary"
            (click)="onAction(1)">{{localService.languageContent.common.add}}</button>
        </div>
      </div>
    </div>
    <div *ngIf="queues">
      <div class="row styled_row" *ngFor="let item of queues">
        <div class="col-1 en">
          <i class="material-icons delete_icon action_icon" (click)="onAction(2,item.key)">cancel</i>
        </div>
        <div class="col-7">
          <span [ngClass]="item.v3 ? localService.getLanguageCode(item.v3) : 'en'">{{item.v4}}</span>
          <span class="en">&nbsp;({{item.v1}})</span>
        </div>
        <div class="col-3 en">
          {{item.v5 | localDate : 'time'}}
        </div>
        <div class="col-1">
          <button class="button_icon button_icon_color"
            (click)="onAction(3,item.key)">airline_seat_recline_normal</button>
        </div>
      </div>
    </div>
  </div>
</div>